export function catalogSort() {
  const select = document.querySelector('.js-catalog-sort');
  if (!select) return;
  select.addEventListener('change', () => {
    location.href = select.value;
  })
}
